
import React, { useState } from 'react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { AnimatePresence, motion } from 'framer-motion'

import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "../styles/language-switcher.scss"
import {useLocation} from "react-router";



const LangSwitcher = () => {

    const { i18n } = useTranslation();

    const changeLanguage = lng => {
        i18n.changeLanguage(lng);
    };
    let location = useLocation();
    const selectedLocale = ((location.pathname.substring(0,4).indexOf('/fr') > -1 ) && 'fr') ||
        (( location.pathname.substring(0,4).indexOf('/nl') > -1 ) && 'nl') ||
        (( location.pathname.substring(0,4).indexOf('/de')  > -1 ) && 'de') ||
        (( location.pathname.substring(0,4).indexOf('/en')  > -1  ) && 'en')

    let nloc = location.pathname.slice(4);

    const locales = [
        {locale :'fr', path :'/accidentinfo/fr/' +nloc},
        {locale :'nl',  path :'/accidentinfo/nl/'+nloc},
        {locale :'en' , path :'/accidentinfo/en/'+nloc},
        {locale :'de' , path :'/accidentinfo/de/'+nloc}]


    const langTranslations = {
        fr: 'Français',
        nl: 'Nederlands',
        en: 'English',
        de: 'Deutch'
    }



    const [open, setOpen] = useState(false)

    const handleMouseEnter = () => {
        setOpen(true)
    }
    const handleMouseLeave = () => {
        setOpen(false)
    }

    const variants = {
        open: {
            height: 'auto',
        },
        close: { height: 0, overflow: 'hidden' },
        colorOn: {
            background: '#003530',
            color: '#ffffff',
            borderRadius: '8px 8px 0 0'
        },
        colorOff: {
            background: '#ffffff',
            color: '#1a4945',
            borderRadius: '8px',

            transition: {
                delay: 0.2
            }
        },
        colorHover: {
            background: '#003530',
            color: '#ffffff'
        }
    }

    return (

        <div className={"container"}>
            <div className={"float-end"}
                 onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave}>
            <DropdownMenu.Root open={open} onOpenChange={setOpen} modal={false}>
                <DropdownMenu.Trigger asChild>
                    <motion.button
                        className={"trigger"}
                        animate={open ? variants.colorOn : variants.colorOff}
                        whileHover={variants.colorHover}
                        aria-label={i18n.label}
                    >
                        {selectedLocale}
                        <FontAwesomeIcon icon={['fas', 'angle-down']} />
                    </motion.button>
                </DropdownMenu.Trigger>
                <AnimatePresence>
                    {open && (
                        <DropdownMenu.Portal forceMount>
                            <DropdownMenu.Content
                                className={"content"}
                                align="end"
                                sideOffset={-20}
                                data-testid="lang-switcher__content"
                                asChild

                            >
                                <motion.div
                                    key="content"
                                    initial={variants.close}
                                    animate={open ? variants.open : variants.close}
                                    exit={variants.close}
                                    transition={{ duration:0.2}}
                                    className={"no-border"}
                                >
                                    {locales.map(
                                        (l, index) => ( l.locale !== selectedLocale ?
                                            <DropdownMenu.Item className={"no-border"} asChild key={index}>
                                                <a
                                                    href={l.path}
                                                    className={"no-border"}
                                                    aria-describedby="lang-switcher__trigger"
                                                    aria-label={langTranslations[l.locale]}
                                                    lang={l.locale}
                                                    hrefLang={l.locale}
                                                >
                                                    {l.locale}
                                                </a>
                                            </DropdownMenu.Item> : ''
                                        )
                                    )}
                                </motion.div>
                            </DropdownMenu.Content>
                        </DropdownMenu.Portal>
                    )}
                </AnimatePresence>
            </DropdownMenu.Root>
        </div>
        </div>
    )
}

export default LangSwitcher
